/**
 * External dependencies
 */
import React from 'react';
import { graphql } from 'gatsby';
import { Form, FormGroup, FormLabel, FormControl } from 'react-bootstrap';
import Helmet from 'react-helmet';

/**
 * Internal dependencies
 */
import { Page, ProductImage, BreadCrumbList } from '../components';
import {
  addToCart,
  noOfItemsInCart,
  addToList,
  noOfItemsInList,
} from '../utilities';

export default class extends React.Component {
  state = {
    btnDisabled: false,
  };

  render() {
    const product = this.props.pageContext;
    this.state.product = product;
    const {
      images,
      brand,
      description,
      categories,
      name,
      price,
      sizes,
      colours,
    } = product;

    const { current, was } = price;
    const arrayOfSizes = sizes ? sizes.split(',') : [];
    const arrayOfColours = colours ? colours.split(',') : [];
    return (
      <Page className={'ProductPage'} title={'Product'}>
        <section
          className="main_item"
          style={{ paddingTop: '30px', paddingBottom: '130px' }}
        >
          <div className="container">
            <BreadCrumbList categories={categories} productName={name} />
            <div className="item-container">
              <ImageContainer images={images} />
            </div>

            <div className="item_content">
              <div className="row">
                <div className="col-md-8 video-info">
                  <h2>{name}</h2>
                  <h4>{brand}</h4>
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <div className="col-md-3">
                  <div>
                    <h3>${parseFloat(current).toFixed(2)}</h3>
                    {was && (
                      <h3 className="wasPrice">
                        Was ${parseFloat(was).toFixed(2)}
                      </h3>
                    )}
                  </div>
                  <div>
                    <FormGroup controlId="sizes">
                      <FormLabel>Select Size</FormLabel>
                      <FormControl as="select">
                        {arrayOfSizes.map(this.renderSelectOption)}
                      </FormControl>
                    </FormGroup>

                    <FormGroup controlId="colors">
                      <FormLabel>Select Color</FormLabel>
                      <FormControl as="select">
                        {arrayOfColours.map(this.renderSelectOption)}
                      </FormControl>
                    </FormGroup>

                    <FormGroup controlId="quantity">
                      <FormLabel>Quantity</FormLabel>
                      <FormControl as="select">
                        <option key="1" value="1">
                          1
                        </option>
                        <option key="2" value="2">
                          2
                        </option>
                        <option key="3" value="3">
                          3
                        </option>
                        <option key="4" value="4">
                          4
                        </option>
                        <option key="5" value="5">
                          5
                        </option>
                        <option key="6" value="6">
                          6
                        </option>
                      </FormControl>
                    </FormGroup>
                  </div>
                  <div className="btn-group" role="group">
                    <button
                      type="button"
                      id="add-to-cart"
                      className="btn btn-info"
                      disabled={this.state.btnDisabled}
                      onClick={(e) => {
                        this.handleAddToCart(product);
                      }}
                    >
                      + ADD TO CART
                    </button>
                  </div>
                  <div className="item-added" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <Helmet
          script={[
            {
              type: 'text/javascript',
              innerHTML: `
                (function() {
                  ${this.handleParticleEvent('view')}
                })()`,
            },
          ]}
        />
      </Page>
    );
  }

  handleParticleEvent = (eventType) => {

    if (typeof window === 'undefined') {
      return;
    }
    if (!window.mParticle) {
      return setTimeout(this.handleParticleEvent, 1000, eventType);
    }
    const { mParticle } = window;
    const { name, sku, price } = this.state.product;
    const product = mParticle.eCommerce.createProduct(name, sku, price.current);
    if (eventType === 'view') {
      console.log('product view');
      mParticle.eCommerce.logProductAction(
        mParticle.ProductActionType.ViewDetail,
        product
      );
    } else if (eventType === 'cart') {
      console.log('cart add');
      mParticle.eCommerce.logProductAction(
        mParticle.ProductActionType.AddToCart,
        product
      );
    }

  };

  handleAddToCart = (product) => {
    const { images, name, brand, price, sku } = product;
    console.log(images);
    const size = document.querySelector('#sizes').value;
    const color = document.querySelector('#colors').value;
    const quantity = document.querySelector('#quantity').value;
    const image = images.alt_images[0].high_res;
    const item = {
      size,
      color,
      image,
      name,
      brand,
      price,
      sku,
      quantity,
    };
    const cartSku = `${sku}-${color}-${size}`;
    addToCart({ [cartSku]: item });
    const noOfItems = noOfItemsInCart();
    document.querySelector('.cart-btn span').innerHTML = noOfItems;
    document.querySelector('.item-added').innerHTML = 'Item added to cart';
    this.handleParticleEvent('cart');
  };

  handleAddToList = (product) => {
    const { images, name, brand, price, sku } = product;
    const size = document.querySelector('#sizes').value;
    const color = document.querySelector('#colors').value;
    const quantity = document.querySelector('#quantity').value;
    const image = images[color] || images[0];
    const item = {
      size,
      color,
      image,
      name,
      brand,
      price,
      sku,
      quantity,
    };
    const listSku = `${sku}-${color}-${size}`;
    addToList({ [listSku]: item });
    const noOfItems = noOfItemsInList();
    document.querySelector('.wishlist-btn span').innerHTML = noOfItems;
    document.querySelector('.item-added').innerHTML = 'Item added to wishlist';
  };

  renderSelectOption = (option) => {
    return (
      <option key={option} value={option}>
        {option}
      </option>
    );
  };
}

const ImageContainer = ({ images }) => {
  const altImage = images.alt_images;
  const altImageCount = altImage.length;

  if (altImageCount < 3) {
    return (
      <React.Fragment>
        <div className="col-md-12">
          <div className={'row'}>
            <div className="col-md-3" />
            <div className="col-md-6">
              <ProductImage
                uri={`${images.alt_images[0].high_res}`}
                height={`500px`}
              />
            </div>
            <div className="col-md-3" />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="norow">
      <div className="col-md-8">
        <ProductImage
          uri={images.alt_images[0].high_res}
          size={'cover'}
          width={'100%'}
          height={`500px`}
        />
      </div>
      <div className="col-md-4">
        <div className="row">
          <div className="col-12">
            <ProductImage
              uri={images.alt_images[1].high_res}
              size={'cover'}
              width={'100%'}
              height={`250px`}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ProductImage
              uri={images.alt_images[2].high_res}
              size={'cover'}
              width={'100%'}
              height={`250px`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const pageQuery = graphql`
  query {
    product {
      images {
        alt_images {
          low_res
          high_res
        }
      }
      brand
      description
      categories
      name
      price {
        current
        was
      }
      sizes
      colours
      sku
    }
  }
`;
